import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { audiences } from '../../data/site';
export function AudienceSection() {
  return <section className="bg-ink pb-24 md:pb-36" data-id="element-29" data-mp="zeqbhvdg4ocz">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:px-8 lg:grid-cols-[1fr_2fr]" data-id="element-30" data-mp="1468cukjdsqyh">
        <Reveal data-id="element-31" data-mp="1481m87ldppa6">
          <div className="lg:sticky lg:top-28" data-id="element-32" data-mp="195lam0bsjifu">
            <h2 className="font-display text-5xl uppercase leading-none md:text-6xl" data-id="element-33" data-mp="194s0qqhjccth">
              Pour les <span className="text-signal" data-id="element-34" data-mp="1d5lrdrmd45q2">organisateurs</span>
            </h2>
            <p className="mt-5 max-w-sm text-paper/60" data-id="element-35" data-mp="1i5q374cbsc9y">
              Un groupe autonome, habitué aux grandes scènes comme aux soirées privées. Vous fournissez la date,
              on s’occupe du reste.
            </p>
          </div>
        </Reveal>

        <ul className="border-t border-paper/15" data-id="element-36" data-mp="3jzpfnt16ozo8">
          {audiences.map((a, i) => <Reveal key={a.title} delay={i * 0.04} data-id="element-37" data-mp="3oyjyuw32cq8v" data-mpi={i}>
              <li data-id="element-38" data-mp="2urn7we8ui7sa">
                <Link to="/organisateurs" className="group relative grid gap-2 overflow-hidden border-b border-paper/15 px-2 py-7 md:grid-cols-[1fr_1.3fr_auto] md:items-center md:gap-8 md:px-4" data-id="element-39" data-mp="2us579jqt124f">
                  <span aria-hidden className="absolute inset-0 origin-bottom scale-y-0 bg-signal transition-transform duration-200 ease-out group-hover:scale-y-100" data-id="element-40" data-mp="2gzyr3xnniv4z" />
                  <span className="relative font-display text-3xl uppercase md:text-4xl" data-id="element-41" data-mp="38qwlr79kwpt3">{a.title}</span>
                  <span className="relative text-paper/70 transition-colors duration-200 group-hover:text-paper" data-id="element-42" data-mp="34oi2wn5wtq1t">
                    {a.description}
                  </span>
                  <ArrowUpRightIcon className="relative hidden h-6 w-6 transition-transform duration-200 group-hover:rotate-45 md:block" data-id="element-43" data-mp="1ta4f1ib5pals" />
                </Link>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}